import classNames from 'classnames'
import type { StatusTone } from '@/types/domain'
import styles from './style.module.css'

interface StatusBadgeProps {
  label: string
  tone?: StatusTone
  className?: string
}

const StatusBadge = ({ className, label, tone = 'neutral' }: StatusBadgeProps) => (
  <span className={classNames(styles.badge, styles[tone], className)}>{label}</span>
)

export default StatusBadge
